let URL={
    _ow_api_captcha_sms_code:'/ow/api/captcha/sms/code',
    _ow_api_save_apply:'/ow/api/save/apply',
}
export default URL